import React, { useContext } from 'react';
import { toDate } from 'date-fns';
import LayoutContext from '../../../contexts/Layout';

import DateTimePickerModal from 'react-native-modal-datetime-picker';
import WebDateTimePicker from '../../common/WebDateTimePicker';

const DatePickerMenu = props => {
    const { layout } = useContext(LayoutContext);
    const handleDateChange = props.handleDateChange;
    const [selectedDate] = props.selectedDateState;
    const [datePickerVisible, setDatePickerVisible] = props.datePickerState;

    if (datePickerVisible) {
        if (layout.device.os.equals('web')) {
            return (
                <WebDateTimePicker
                    onSelect={date => {
                        handleDateChange(toDate(date));
                        setDatePickerVisible(false);
                    }}
                    value={selectedDate}
                />
            );
        } else {
            return (
                <DateTimePickerModal
                    isVisible={datePickerVisible}
                    onCancel={() => setDatePickerVisible(false)}
                    onConfirm={date => {
                        handleDateChange(date);
                        setDatePickerVisible(false);
                    }}
                    mode='date'
                    value={selectedDate}
                />
            );
        }
    }
}; //, [datePickerVisible, handleDateChange, layout.device.os, selectedDate]);

export default DatePickerMenu;
